(function () {
  var root = document.querySelector('[data-make]');
  if (!root) return;

  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-moment]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-panel]'));
  var formats = Array.prototype.slice.call(root.querySelectorAll('[data-format]'));
  var tabStrip = root.querySelector('.fp-make__moments');
  var formatRow = root.querySelector('.fp-make__format-grid');

  function formatsFor(tab) {
    return (tab.getAttribute('data-formats') || '').split(' ');
  }

  function select(index, moveFocus) {
    var active = tabs[index];
    if (!active) return;
    var moment = active.getAttribute('data-moment');
    var matches = formatsFor(active);

    tabs.forEach(function (tab, i) {
      var on = i === index;
      tab.classList.toggle('is-on', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var on = panel.getAttribute('data-panel') === moment;
      panel.classList.toggle('is-on', on);
      panel.hidden = !on;
      if (on) {
        var photo = panel.querySelector('img');
        if (photo) photo.loading = 'eager';
      }
    });

    formats.forEach(function (card) {
      var match = matches.indexOf(card.getAttribute('data-format')) !== -1;
      var tag = card.querySelector('.fp-format__tag');
      card.classList.toggle('is-match', match);
      if (tag) tag.setAttribute('aria-hidden', match ? 'false' : 'true');
    });
    root.classList.add('has-match');

    if (moveFocus) active.focus();
    scrollRowTo(tabStrip, active);
    scrollRowTo(formatRow, root.querySelector('.fp-format.is-match'));
  }

  function scrollRowTo(row, item) {
    if (!row || !item || row.scrollWidth <= row.clientWidth) return;
    var left = item.getBoundingClientRect().left - row.getBoundingClientRect().left + row.scrollLeft - 24;
    row.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }

  tabs.forEach(function (tab, index) {
    tab.addEventListener('click', function () { select(index, false); });
    tab.addEventListener('keydown', function (event) {
      var next = null;
      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === null) return;
      event.preventDefault();
      select(next, true);
    });
  });

  formats.forEach(function (card) {
    var name = card.getAttribute('data-format');
    function relate(on) {
      tabs.forEach(function (tab) {
        tab.classList.toggle('is-related', on && formatsFor(tab).indexOf(name) !== -1);
      });
    }
    card.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') relate(true); });
    card.addEventListener('pointerleave', function () { relate(false); });
    card.addEventListener('focus', function () { relate(true); });
    card.addEventListener('blur', function () { relate(false); });
  });

  // Warm up the other stage photos once the section is near, so switching never flashes blank.
  if ('IntersectionObserver' in window) {
    var warm = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) return;
      panels.forEach(function (panel) {
        var photo = panel.querySelector('img');
        if (photo) photo.loading = 'eager';
      });
      warm.disconnect();
    }, { rootMargin: '400px 0px' });
    warm.observe(root);
  }

  select(0, false);
})();
